var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInfillPartial = function SvgInfillPartial(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1890FF",
    d: "M20.0624 17.2005L18.8846 14.9897C18.7229 14.6856 18.286 14.6905 18.1315 14.9994L16.9827 17.2874C16.7776 17.6398 16.6883 18.0646 16.7679 18.5183C16.8958 19.2448 17.4751 19.8337 18.1991 19.9712C19.3528 20.1885 20.3592 19.3075 20.3592 18.1949C20.3592 17.828 20.2506 17.4901 20.0624 17.2053V17.2005Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#494949",
    d: "M9.35599 2.17639C9.10498 1.92539 8.68986 1.94228 8.46057 2.22225C8.26025 2.46602 8.30369 2.83046 8.52815 3.05491L10.249 4.77575L4.00764 11.0171C3.52252 11.5022 3.52252 12.289 4.00764 12.7766L10.2224 18.9914C10.7076 19.4765 11.4944 19.4765 11.9819 18.9914L18.1967 12.7766C18.6818 12.2914 18.6818 11.5046 18.1967 11.0171L9.35599 2.17639ZM11.101 5.62772L16.8331 11.3598C17.031 11.5577 16.891 11.8956 16.611 11.8956H5.5909C5.31093 11.8956 5.17095 11.5577 5.36886 11.3598L11.101 5.63013V5.62772Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#1890FF",
    d: "M5.54993 14.3091L10.2225 18.9889C10.7076 19.474 11.4944 19.474 11.9819 18.9889L16.6545 14.3091H5.54993Z"
  })));
};
export default SvgInfillPartial;